
const lastUpdate = '2026-03-15';
export const helpTitle = 'Permission Manager';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Permission Manager controls role-based access across EasyMap. Use it to view what each role can do, and to grant or revoke permissions as needed.</p>

<h2>How Permissions Are Organized</h2>
<p>Permissions are organized by <strong>module</strong>:</p>
<ul>
  <li>Wildfires, Weather, Stations, Duty Log, VAR, and others.</li>
</ul>
<p>Within each module, permissions are defined by <strong>operation</strong>:</p>
<ul>
  <li><strong>Read</strong> — View data.</li>
  <li><strong>Create</strong> — Add new records.</li>
  <li><strong>Update</strong> — Edit existing records.</li>
  <li><strong>Delete</strong> — Remove records.</li>
  <li><strong>Export</strong> — Download data.</li>
  <li><strong>Manage</strong> — Administrative control over the module.</li>
</ul>

<h2>Granting and Revoking Permissions</h2>
<ul>
  <li>Select a <strong>role</strong> from the list to see its current permissions.</li>
  <li>Toggle any permission to grant or revoke it.</li>
  <li>Click <strong>Save</strong> to apply your changes.</li>
</ul>

<h2>When Changes Take Effect</h2>
<p>Permission changes take effect after the <strong>server cache is rebuilt</strong>. This may take a few moments. Users currently logged in will need to reload the application to see updated permissions.</p>

<p><em>This tool is available to administrators only.</em></p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
